import { useEffect, useState } from 'react';
import { getOrderGenieProductImageBaseUrl } from '../../services/orderXApi';

// Fetches the "Fallback Product Image Base URL" (AHRI Data > Match Lookup)
// once per mount -- pair with buildProductImageUrl (orderXV4Utils.js) to
// resolve a bare filename in an image_url field the same way AHRI Search >
// Products does. Failure is non-fatal: resolves to '', so
// buildProductImageUrl just returns the raw value unprefixed.
export const useProductImageBaseUrl = () => {
  const [baseUrl, setBaseUrl] = useState('');
  useEffect(() => {
    let cancelled = false;
    getOrderGenieProductImageBaseUrl().then((url) => {
      if (!cancelled) setBaseUrl(url);
    });
    return () => {
      cancelled = true;
    };
  }, []);
  return baseUrl;
};
